module.exports = __webpack_public_path__ + "static/media/app_landing_video.69d3b233.mp4";